import styles from '../../assets/styles/BusinessInsights/BusinessInsights.module.scss';
import { AppPage, MimaText, ReceiptCheckBox as RCB } from '../../components';
import { BusinessInsightComponent as BIC } from '../../components/Home';
import { AdditionalInfoContainer } from '../../containers';
import Checkbox1 from '../../assets/img/checkbox1.png';
import Checkbox2 from '../../assets/img/checkbox2.png';
import Checkbox3 from '../../assets/img/checkbox3.png';
import Checkbox4 from '../../assets/img/checkbox4.png';
import Checkbox5 from '../../assets/img/checkbox5.png';
import Checkbox6 from '../../assets/img/checkbox6.png';
import Checkbox7 from '../../assets/img/checkbox7.png';
import { amountFormatter } from '../../utils/utils';
import { AnimatePresence } from 'framer-motion';
import Info from '../../assets/img/info.png';
import { FaCalendar } from 'react-icons/fa';
import React from 'react';

const BusinessInsights = ({ openModal, businessInsightsModal, closeModal }) => {
	const productData = [
		{
			sn: '1',
			product: 'Agbada',
			orders: '10',
			totalAmount: 'NGN 700,000',
			customer: 'James Bond',
		},
		{
			sn: '2',
			product: 'Wristwatch',
			orders: '9',
			totalAmount: 'NGN560,000',
			customer: 'Bruce Lee',
		},
		{
			sn: '3',
			product: 'Necklace',
			orders: '7',
			totalAmount: 'NGN 300,000',
			customer: 'Jason Statham',
		},
		{
			sn: '4',
			product: 'Clearning service',
			orders: '4',
			totalAmount: 'NGN 200,000',
			customer: 'Jackie Chan',
		},
		{
			sn: '5',
			product: 'Shoe',
			orders: '3',
			totalAmount: 'NGN 100,000',
			customer: 'Jet LI',
		},
	];

	const expenseData = [
		{
			icon: <img src={Checkbox1} />,
			name: 'Salary',
			deposit: 'N150,000',
		},
		{
			icon: <img src={Checkbox2} />,
			name: 'Raw Material',
			deposit: 'N125,000',
		},
		{
			icon: <img src={Checkbox3} />,
			name: 'Airtime',
			deposit: 'N105,000',
		},
		{
			icon: <img src={Checkbox4} />,
			name: 'Fuel',
			deposit: 'N80,000',
		},
		{
			icon: <img src={Checkbox5} />,
			name: 'Data',
			deposit: 'N65,000',
		},
		{
			icon: <img src={Checkbox6} />,
			name: 'Waste Disposal',
			deposit: 'N50,000',
		},
		{
			icon: <img src={Checkbox7} />,
			name: 'Other',
			deposit: 'N35,000',
		},
	];

	return (
		<div>
			<AppPage pageTitle="Business Insights">
				<div className={styles.bi__content}>
					<BIC
						title="Total Income"
						deposit={amountFormatter().format(123.5)}
						styleClass={styles.bi__income}
					/>
					<BIC
						title="Total Profit"
						deposit={amountFormatter().format(100)}
						styleClass={styles.bi__profit}
					/>
					<BIC
						title="Max Credit Access"
						deposit={amountFormatter().format(23.5)}
						styleClass={styles.bi__credit}
					/>
					<BIC
						title="Total Expenses"
						deposit={amountFormatter().format(23.5)}
						styleClass={styles.bi__expenses}
					/>
					<BIC title="Total Sales" deposit={10} styleClass={styles.bi__sales} />
					<BIC
						title="Business Health"
						deposit="Growing"
						styleClass={styles.bi__health}
					/>
				</div>

				<div className={styles.bi__info} onClick={businessInsightsModal}>
					<img src={Info} alt="info icon" />
					<span>Additional info</span>
				</div>

				<MimaText variant="subtitle" mt={4} align="center">
					Income Analysis
				</MimaText>

				<div className={styles.bi__sideCards}>
					<div className={styles.bi__mainCards}>
						<MimaText variant="subtitleBold" align="center">
							Products
						</MimaText>

						<div className={styles.card_top}>
							<div className={styles.card_top_icon}>
								<FaCalendar /> All Time
							</div>
							<div className={styles.card_top_filter}>
								<RCB title="Amount" id="productByAmount" name="productFilter" />
								<RCB
									title="No of Orders"
									id="productByOrders"
									name="productFilter"
								/>
							</div>
						</div>

						<MimaText variant="bodyBold" mb={3}>
							Top 5 Products
						</MimaText>
						<table>
							<tbody>
								{productData.map(value => (
									<tr key={value.sn}>
										<td> {value.sn} </td>
										<td> {value.product} </td>
										<td> {value.orders} </td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className={styles.bi__mainCards}>
						<MimaText variant="subtitleBold" align="center">
							Customers
						</MimaText>

						<div className={styles.card_top}>
							<div className={styles.card_top_icon}>
								<FaCalendar /> All Time
							</div>
							<div className={styles.card_top_filter}>
								<RCB title="Amount" id="productByAmount" name="productFilter" />

								<RCB
									title="No of Orders"
									id="productByOrders"
									name="productFilter"
								/>
							</div>
						</div>

						<MimaText variant="bodyBold" mb={3}>
							Top 5 Customers
						</MimaText>
						<table>
							<tbody>
								{productData.map(value => (
									<tr key={value.sn}>
										<td> {value.sn} </td>
										<td> {value.customer}</td>
										<td> {value.orders} </td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>

				{openModal && (
					<div className="modal">
						<AnimatePresence>
							{openModal && <AdditionalInfoContainer closeModal={closeModal} />}
						</AnimatePresence>
					</div>
				)}
			</AppPage>
		</div>
	);
};

export default BusinessInsights;
